module.exports = __webpack_public_path__ + "static/COUNSELLING-42ad9ca28869dafa32898382c6ca7700.png";